import { render, staticRenderFns } from "./tutorial-proposals.vue?vue&type=template&id=29292328&scoped=true&"
import script from "./tutorial-proposals.vue?vue&type=script&lang=js&"
export * from "./tutorial-proposals.vue?vue&type=script&lang=js&"
import style0 from "./tutorial-proposals.vue?vue&type=style&index=0&id=29292328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29292328",
  null
  
)

export default component.exports